import React, { Component } from 'react';
import { Pagination } from 'antd';
import styles from './pagination.less';

export default class MyPagination extends Component {
  renderMessagePagination(messagePagination) {
    const { totalElement } = messagePagination;
    const { getMessage } = this.props
    return (
      <Pagination
        size="small"
        total={totalElement}
        onChange={noop => getMessage(noop - 1, 10)}
      />
    );
  }

  renderLeaveWordPagination = (leaveWordPagination) => {
    const { totalElement } = leaveWordPagination || {};
    const { changeLeaveWordPage } = this.props
    return (
      <Pagination
        total={totalElement}
        onChange={noop => changeLeaveWordPage(noop - 1)}
      />
    );
  }

  render() {
    const { type, messagePagination, leaveWordPagination } = this.props;
    return (
      <div className={styles.pagination}>
        {type === 'message' && this.renderMessagePagination(messagePagination)}
        {type === 'leaveWord' && this.renderLeaveWordPagination(leaveWordPagination)}
      </div>
    );
  }
}
